var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4.00066C10.79 4.00047 8.99985 5.79033 8.99967 8.00033C8.99949 10.2103 10.7893 12.0005 12.9993 12.0007C15.2093 12.0008 16.9995 10.211 16.9997 8.00098C16.9999 5.79098 15.21 4.00084 13 4.00066ZM14.9997 8.00082C14.9998 6.90082 14.0998 6.00075 12.9998 6.00066C11.8998 6.00057 10.9998 6.90049 10.9997 8.00049C10.9996 9.10049 11.8995 10.0006 12.9995 10.0007C14.0995 10.0007 14.9996 9.10082 14.9997 8.00082ZM18.9989 18.0011C18.7989 17.2911 15.699 16.0009 12.999 16.0007C10.309 16.0004 7.22891 17.2802 6.99885 18.0002L18.9989 18.0011ZM4.99885 18C4.99907 15.34 10.3292 14.0004 12.9992 14.0007C15.6692 14.0009 20.9991 15.3413 20.9989 18.0013L20.9987 20.0013L4.99869 20L4.99885 18Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson24Px);
export default __webpack_public_path__ + "static/media/person_24px.01b81e077723a971d8e7f3fb62d96320.svg";
export { ForwardRef as ReactComponent };